import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局样式
import './assets/css/global.css'
import './assets/css/main.css'

// element-ui
import './untils/element-ui'

// jquery
import $ from 'jquery'
Vue.prototype.$ = $

// amfe-flexible
import './untils/amfe-flexible.js'
import './assets/css/fonts/font.css'

// axios
import axios from './untils/axios-config.js'
Vue.prototype.$axios = axios

// moment
import moment from 'moment'
Vue.filter('dateFilter', (dateMsg, filterModel = 'YYYY-MM-DD') => {
  return moment(dateMsg).format(filterModel)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
